import { apiService } from "./apiService";
import {
  ActualizarProductoComponenteDto,
  AsociarProductoComponenteDto,
  ComponenteGarantia,
  CreaComponenteGarantiaDto,
  ProductoComponenteGarantia,
} from "../dtos/ComponenteGarantia";

export const componentesGarantiaService = {
  async getAll(soloActivos = true): Promise<ComponenteGarantia[]> {
    return apiService.get<ComponenteGarantia[]>(
      `/api/ComponentesGarantia?soloActivos=${soloActivos}`,
    );
  },

  async getById(id: string): Promise<ComponenteGarantia> {
    return apiService.get<ComponenteGarantia>(`/api/ComponentesGarantia/${id}`);
  },

  async create(dto: CreaComponenteGarantiaDto): Promise<ComponenteGarantia> {
    return apiService.post<ComponenteGarantia, CreaComponenteGarantiaDto>(
      "/api/ComponentesGarantia",
      dto,
    );
  },

  async update(
    id: string,
    dto: CreaComponenteGarantiaDto,
  ): Promise<ComponenteGarantia> {
    return apiService.put<ComponenteGarantia, CreaComponenteGarantiaDto>(
      `/api/ComponentesGarantia/${id}`,
      dto,
    );
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/api/ComponentesGarantia/${id}`);
  },

  async getByProducto(
    codigoProducto: number,
    soloActivos = false,
  ): Promise<ProductoComponenteGarantia[]> {
    return apiService.get<ProductoComponenteGarantia[]>(
      `/api/Productos/${codigoProducto}/componentes?soloActivos=${soloActivos}`,
    );
  },

  async asociar(
    codigoProducto: number,
    dto: AsociarProductoComponenteDto,
  ): Promise<ProductoComponenteGarantia> {
    return apiService.post<ProductoComponenteGarantia, AsociarProductoComponenteDto>(
      `/api/Productos/${codigoProducto}/componentes`,
      dto,
    );
  },

  async actualizarAsociacion(
    codigoProducto: number,
    id: string,
    dto: ActualizarProductoComponenteDto,
  ): Promise<ProductoComponenteGarantia> {
    return apiService.put<ProductoComponenteGarantia, ActualizarProductoComponenteDto>(
      `/api/Productos/${codigoProducto}/componentes/${id}`,
      dto,
    );
  },

  async desasociar(codigoProducto: number, id: string): Promise<void> {
    await apiService.delete(`/api/Productos/${codigoProducto}/componentes/${id}`);
  },
};
